import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EstadosBrasil, NomesEstadosBrasil } from 'src/app/enum/estadosBrasil.enum';
import { CidadeService } from 'src/app/service/cidade.service';
import { ViaCepService } from 'src/app/service/viaCep.service';
import { Utils } from 'src/app/util/utils';

@Component({
  selector: 'app-endereco-cadastro',
  templateUrl: './endereco-cadastro.component.html',
})
export class EnderecoCadastroComponent {

  @Input() formulario!: FormGroup;
  @Input() showObservation = false;

  estados = Object.values(EstadosBrasil);
  cidades: string[] = [];
  errorMessage = '';

  constructor(
    private viaCepService: ViaCepService,
    private cidadeService: CidadeService,
    private utils: Utils,
  ) { }

  getSiglaEstado(estado: EstadosBrasil) {
    return NomesEstadosBrasil.get(estado);
  }

  buscarDadosCep(): void {
    const cep = this.formulario.get('cep')?.value;
    if (this.utils.isNullOrEmpty(cep)) {
      this.limparEndereco();
      return;
    }
    this.viaCepService.buscarCep(cep).subscribe(resposta => {
      this.formulario.patchValue({
        estado: resposta.estado,
        cidade: resposta.localidade,
        bairro: resposta.bairro,
        address: resposta.logradouro,
      });
      this.buscarMunicipios(this.buscarSiglaEstadoInformado(resposta.estado));
    }, () => this.limparEndereco());
  }

  buscarMunicipios(uf: string): void {
    if (this.utils.isNullOrEmpty(uf)) {
      return;
    }
    this.cidadeService.buscarMunicipios(uf).subscribe(resposta => {
      this.cidades = resposta;
    });
  }

  limparEndereco() {
    this.formulario.patchValue({
      estado: '',
      cidade: '',
      bairro: '',
      address: '',
    });
  }

  buscarSiglaEstadoInformado(estado: string): string {
    if (this.utils.isNullOrEmpty(estado)) {
      return '';
    }
    const sigla = Object.entries(EstadosBrasil).find(
      ([, nome]) => nome.toLowerCase() === estado.toLowerCase()
    )?.[0];
    return sigla || '';
  }
}
